/* unplugin-vue-components disabled */import script from "./VerificationResult.vue?vue&type=script&lang=ts&setup=true"
export * from "./VerificationResult.vue?vue&type=script&lang=ts&setup=true"

import "./VerificationResult.vue?vue&type=style&index=0&id=0e93c640&lang=less&scoped=true"

import exportComponent from "/Users/zhaoshunchen/Desktop/job/sinosig/workspace/shuke/sinosig-app-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e93c640"]])

export default __exports__